var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPatientUsa(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 181.115,
    height: 64.664,
    viewBox: "0 0 181.115 64.664",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "@import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');"), /*#__PURE__*/React.createElement("filter", {
    id: "Path_3981",
    x: 133.134,
    y: 7,
    width: 47.981,
    height: 57.664,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_3982",
    x: 133.134,
    y: 17,
    width: 29.981,
    height: 47.664,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_2085",
    x: 0,
    y: 0,
    width: 163.115,
    height: 57.664,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4122",
    "data-name": "Group 4122",
    transform: "translate(-1298.137 -136.186)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1298.14, 136.19)",
    filter: "url(#Path_3981)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3981-2",
    "data-name": "Path 3981",
    d: "M34.859-70H4.878v39.664H34.859l-11-20.454Z",
    transform: "translate(137.26 83)",
    fill: "#a30404"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1298.14, 136.19)",
    filter: "url(#Path_3982)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3982-2",
    "data-name": "Path 3982",
    d: "M12.859-60H.878v29.664l11.914-6.98Z",
    transform: "translate(141.26 83)",
    fill: "#791010"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1298.14, 136.19)",
    filter: "url(#Path_2085)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2085-2",
    "data-name": "Path 2085",
    d: "M145.993-70H.878v39.664H145.993Z",
    transform: "translate(8.12 76)",
    fill: "#c00"
  })), /*#__PURE__*/React.createElement("text", {
    id: "USA_Patented",
    "data-name": "USA Patented",
    transform: "translate(1325 158)",
    fill: "#fff",
    fontSize: 12,
    fontFamily: "Montserrat-Regular, Montserrat"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "PATENTED in the")), /*#__PURE__*/React.createElement("text", {
    id: "Soon_in_Canada",
    "data-name": "Soon in Canada",
    transform: "translate(1322 174)",
    fill: "#fff",
    fontSize: 14,
    fontFamily: "Montserrat-Bold, Montserrat",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "USA and Canada")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientUsa);
export default __webpack_public_path__ + "static/media/patient-usa.a39f0dcdf830e6e1ec5146113ffda350.svg";
export { ForwardRef as ReactComponent };